export default "__VITE_ASSET__m19jmw9K9uYTxG0jJcxFFQ__"